module.exports = __webpack_public_path__ + "img/ceo.14cd9eed.jpg";